// Import will be used when we re-enable Supabase function calls
import { supabase } from "@/lib/supabase"
import { getSupabaseFunctionErrorMessage } from "@/utils/supabaseFunctionUtils"

export interface ScheduleSessionRequest {
  jobId: string
  applicationId: string // Changed from applicantId to applicationId to match Supabase function requirements
  sessionId: string
  date: string
}

export interface ScheduleSessionResponse {
  success: boolean
  message?: string
  bookingId?: string
  error?: string
}

export const scheduleOrientation = async (
  request: ScheduleSessionRequest,
): Promise<ScheduleSessionResponse> => {
  // Uncomment when Supabase function is ready

  try {
    const { data, error } = await supabase.functions.invoke<ScheduleSessionResponse>(
      "schedule-orientation",
      {
        body: request,
      },
    )

    if (error) {
      const message = await getSupabaseFunctionErrorMessage(error)
      throw new Error(message)
    }

    return data || { success: false, error: "No response from server" }
  } catch (error) {
    console.error("Error scheduling orientation:", error)
    throw error
  }
}

export const scheduleVehicleCollection = async (
  request: ScheduleSessionRequest,
): Promise<ScheduleSessionResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke<ScheduleSessionResponse>(
      "schedule-vehicle-collection",
      {
        body: request,
      },
    )

    if (error) {
      const message = await getSupabaseFunctionErrorMessage(error)
      throw new Error(message)
    }

    return data || { success: false, error: "No response from server" }
  } catch (error) {
    console.error("Error scheduling vehicle collection:", error)
    throw error
  }
}
